import { Injectable } from '@angular/core';
import { GLOBAL } from './global';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CombosService {
  public url: string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    public _http: HttpClient
  ) {
    this.url = GLOBAL.url;
  }

  getEstados(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/edos', { headers });
   }

   getAsentamientos(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/asentamientos', { headers });
   }

   getVialidades(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/vialidades', { headers });
   }

   getEdoCivil(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/estadocivil', { headers });
   }

   getMunicipios(idEdo): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/muns/' + idEdo, { headers });
   }

   getLocalidades(idEdo, idLoc): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/locs/' + idEdo + '/' + idLoc, { headers });
   }

   getAsociaciones(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/asociaciones', { headers });
   }

   getActividades(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/actividades', { headers });
   }

   getTiposUpaegGrupal(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/tipos/grupos', { headers });
   }

   getTiposDomicilio(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/tipos/domicilio', { headers });
   }

   getDocumentosForRequisito(idRequisito): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/documentos/requisito/'+idRequisito, { headers });
   }


   getTiposSistemaProd(): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/tipos/sistema/producto', { headers });
   }

   getSistemaProductutoForTipo(idTipoSistema): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this._http.get(this.url + 'get/combo/sistema/producto/' + idTipoSistema, { headers });
   }












}
